import { ASSISTANT, INSPECTIONS, WORKS } from '../utils/URLS';
import AuthService from './AuthService';

// Error tipado por status para que la UI elija el copy.
export class AssistantError extends Error {
  constructor(kind, message) {
    super(message);
    this.kind = kind; // 'unconfigured' | 'limit' | 'auth' | 'network' | 'unknown'
  }
}

const authHeaders = () => ({
  'Content-Type': 'application/json',
  Authorization: `Bearer ${AuthService.getAccessToken()}`,
});

class AssistantService {
  static async sendMessage({ message, history = [], highReasoning = false }) {
    let response;
    try {
      response = await fetch(ASSISTANT.CHAT, {
        method: 'POST',
        headers: authHeaders(),
        body: JSON.stringify({ message, history, highReasoning }),
      });
    } catch (e) {
      throw new AssistantError('network', 'No pudimos conectar');
    }

    if (!response.ok) {
      if (response.status === 503) throw new AssistantError('unconfigured', 'No disponible');
      if (response.status === 429) throw new AssistantError('limit', 'Límite alcanzado');
      if (response.status === 401) throw new AssistantError('auth', 'Sesión vencida');
      throw new AssistantError('unknown', 'Error inesperado');
    }

    const data = await response.json().catch(() => ({}));
    return {
      reply: data.reply || '',
      model: data.model || '',
      toolsUsed: Array.isArray(data.toolsUsed) ? data.toolsUsed : [],
      pendingActions: Array.isArray(data.pendingActions) ? data.pendingActions : [],
      artifacts: Array.isArray(data.artifacts) ? data.artifacts : [],
    };
  }

  // Ejecuta una acción propuesta (Fase 2) contra el endpoint de creación existente,
  // que re-valida server-side. Se llama SOLO cuando el humano confirma.
  static async executeAction(proposal) {
    const { action, data } = proposal || {};
    let url;
    let body;
    if (action === 'crear_inspeccion') {
      const { personId, ...rest } = data;
      url = `${INSPECTIONS.BY_PERSON}${personId}`;
      body = rest;
    } else if (action === 'crear_obra') {
      url = WORKS.LIST;
      body = data;
    } else if (action === 'enviar_email') {
      url = ASSISTANT.SEND_EMAIL;
      body = { to: data.to, subject: data.subject, html: data.html, ics: data.ics };
    } else {
      throw new AssistantError('unknown', 'Acción no soportada');
    }

    let response;
    try {
      response = await fetch(url, {
        method: 'POST',
        headers: authHeaders(),
        body: JSON.stringify(body),
      });
    } catch (e) {
      throw new AssistantError('network', 'No pudimos conectar');
    }

    if (!response.ok) {
      const d = await response.json().catch(() => ({}));
      const msg = Array.isArray(d.message)
        ? d.message.join(', ')
        : d.message || 'No se pudo crear';
      throw new AssistantError('unknown', msg);
    }
    return response.json().catch(() => ({}));
  }
}

export default AssistantService;
